import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {GestionClientsRoutingModule} from './gestion-clients-routing.module';
import {SharedModule} from '../shared/shared.module';
import {ClientFicheIdentiteComponent} from './clients/client/fiche-identite/client-fiche-identite.component';
import {CoreModule} from '../core/core.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {GridClientsComponent} from "./grille-clients/grid-clients.component";
import {ClientComponent} from "./clients/client.component";
import {PointDeLivraisonComponent} from "./points-de-livraison/point-de-livraison/point-de-livraison.component";
import {PointDeLivraisonFicheIdentiteComponent} from "./points-de-livraison/point-de-livraison/fiche-identite/point-de-livraison-fiche-identite.component";
import {PointDeLivraisonConditionnementComponent} from "./points-de-livraison/point-de-livraison/conditionnement/point-de-livraison-conditionnement.component";
import {
  DxDataGridModule,
  DxDateBoxModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule,
  DxLookupModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxSelectBoxModule,
  DxTabPanelModule,
  DxTabsModule,
  DxTagBoxModule,
  DxToolbarModule
} from "devextreme-angular";
import {LiaisonPlcMcPlcComponent} from "./points-de-livraison/point-de-livraison/conditionnement/liaisons/dialog/liaison-plc-mc-plc.component";
import {LiaisonsComponent} from "./points-de-livraison/point-de-livraison/conditionnement/liaisons/liaisons.component";
import {ReglesRegroupementComponent} from "./points-de-livraison/point-de-livraison/conditionnement/regles/regles-regroupement.component";
import {TabMenuModule} from "primeng/tabmenu";
import {SelectButtonModule} from 'primeng/selectbutton';
import {PointDeLivraisonPrestationComponent} from "./points-de-livraison/point-de-livraison/prestation/point-de-livraison-prestation.component";
import {FermetureClientsComponent} from './fermeture/fermeture-clients.component';
import {FermetureAddAreaComponent} from './fermeture/add-area/fermeture-add-area.component';
import {FermeturePreviewJourComponent} from './fermeture/preview-jour/fermeture-preview-jour.component';
import {FermeturePreviewPeriodeComponent} from './fermeture/preview-periode/fermeture-preview-periode.component';
import {FermetureErreurJourComponent} from './fermeture/erreur-jour/fermeture-erreur-jour.component';
import {FermetureErreurPeriodeComponent} from './fermeture/erreur-periode/fermeture-erreur-periode.component';
import {JourSemaineListPipe} from "../core/pipe/jour-semaine-list.pipe";

@NgModule({
  imports: [
    CommonModule,
    GestionClientsRoutingModule,
    SharedModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,

    TabMenuModule,
    SelectButtonModule,
    DxDataGridModule,
    DxPopupModule,
    DxLookupModule,
    DxToolbarModule,
    DxTabPanelModule,
    DxTabsModule,
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxTagBoxModule,
    DxDateBoxModule,
    JourSemaineListPipe,
    DxLoadIndicatorModule,
    DxLoadPanelModule,
  ],
  declarations: [
    ClientComponent,
    ClientFicheIdentiteComponent,
    PointDeLivraisonComponent,
    PointDeLivraisonFicheIdentiteComponent,
    PointDeLivraisonConditionnementComponent,
    LiaisonPlcMcPlcComponent,
    GridClientsComponent,
    LiaisonsComponent,
    ReglesRegroupementComponent,
    PointDeLivraisonPrestationComponent,
    FermetureClientsComponent,
    FermetureAddAreaComponent,
    FermeturePreviewJourComponent,
    FermeturePreviewPeriodeComponent,
    FermetureErreurJourComponent,
    FermetureErreurPeriodeComponent
  ]
})
export class GestionClientsModule { }
